import { Prospect } from './prospect';

export class Contact {
    nom: string;
    mobile: string;
    tel: String;
    mail: string;
    adresse: String;
    contactId: number;
    fax: String;
    lieu: String;
    nPassport: String;
    nationalite: String;
    selected: boolean;
    originecontact: String;
    titres: string;
    prospectId: Prospect;
    titreId: Titre;
typeContact:string;
 
}

export class Titre {
    titreId: Number;


    designation: string;
}
